import PropTypes from 'prop-types';
import portalContainerPropType from '../portal/container_prop_type';
var deprecatedPlacements = ['left-end', 'left-start', 'left', 'right-end', 'right-start', 'right'];
var popoverPlacements = [...deprecatedPlacements, 'bottom-end', 'bottom-start', 'bottom', 'leading-end', 'leading-start', 'leading', 'top-end', 'top-start', 'top', 'trailing-end', 'trailing-start', 'trailing'];
var propTypes = {
  anchorEl: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    getBoundingClientRect: PropTypes.func
  }), typeof Element === 'undefined' ? PropTypes.any : PropTypes.instanceOf(Element)]),
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
  fixed: PropTypes.bool,
  flip: PropTypes.bool,
  id: PropTypes.string,
  keepMounted: PropTypes.bool,
  modifiers: PropTypes.array,
  onChangePlacement: PropTypes.func,
  open: PropTypes.bool,
  placement: (props, propName, componentName) => {
    var value = props[propName];
    if (!popoverPlacements.includes(value)) {
      return new Error("Invalid prop `".concat(propName, "` supplied to") + " `".concat(componentName, "`. Validation failed."));
    }
    if (deprecatedPlacements.includes(value)) {
      var [first, last] = value.split('-');
      var newPropValue = [first[0] === 'left' ? 'leading' : 'trailing', last].filter(Boolean).join('-');
      return new Error(["@veneer/core: The value `".concat(value, "` supplied to `").concat(componentName, ".").concat(propName, "` was deprecated."), "Use the placement `".concat(newPropValue, "` instead.")].join('\n'));
    }
    return null;
  },
  portal: PropTypes.bool,
  portalContainer: portalContainerPropType,
  role: PropTypes.string,
  style: PropTypes.shape({}),
  transition: PropTypes.bool
};
export default propTypes;
export { popoverPlacements };